import { useContext } from "react";
import { MasajidContext } from "../contexts/MasajidContext";
import ShareButton from "./ShareButton";
import FavouriteButton from "./FavouriteButton";
import MyMasjidButton from "./MyMasjidButton";

function MasjidInfo({
  timings,
  nextChanges,
  fixedTimes,
  announcements,
  details,
  username,
}) {
  const noNextChanges = {
    fajr: ["anjumanmasjid"],
    asr: [],
    isha: [],
  };
  const { language } = useContext(MasajidContext);

  function adjustTime(timeStr, minutesToAdd) {
    let [hours, minutes] = timeStr.split(":").map(Number);
    minutes += minutesToAdd;

    while (minutes < 0) {
      hours -= 1;
      minutes += 60;
    }

    while (minutes >= 60) {
      hours += 1;
      minutes -= 60;
    }

    hours = (hours + 24) % 24;

    return ("0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2);
  }

  function twentyFourToTwelve(time) {
    let parts = time.split(":");
    let hours = parts[0];
    let minutes = parts[1];
    hours = hours % 12;
    hours = hours ? hours : 12;
    if (hours < 10) {
      hours = "0" + hours;
    }
    return hours + ":" + minutes;
  }

  const Months = {
    1: { english: "Jan", urdu: "جنوری" },
    2: { english: "Feb", urdu: "فروری" },
    3: { english: "Mar", urdu: "مارچ" },
    4: { english: "Apr", urdu: "اپریل" },
    5: { english: "May", urdu: "مئی" },
    6: { english: "Jun", urdu: "جون" },
    7: { english: "Jul", urdu: "جولائی" },
    8: { english: "Aug", urdu: "اگست" },
    9: { english: "Sep", urdu: "ستمبر" },
    10: { english: "Oct", urdu: "اکتوبر" },
    11: { english: "Nov", urdu: "نومبر" },
    12: { english: "Dec", urdu: "دسمبر" },
  };

  function formatDate(day, month, calendar) {
    if (calendar === "shamsi") {
      const today = new Date();
      const changeDate = new Date(today.getFullYear(), month - 1, day);

      const persianDay = new Intl.DateTimeFormat("en-US-u-ca-persian", {
        day: "numeric",
      }).format(changeDate);
      const persianMonth = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        month: "long",
      }).format(changeDate);

      return (
        <>
          {persianDay} <span lang="ur">{persianMonth}</span>
        </>
      );
    } else {
      return (
        <>
          {day}{" "}
          <span lang={language === "urdu" && "ur"}>
            {Months[month][language]}
          </span>
        </>
      );
    }
  }

  const todayTimings = {
    fajrJamaat: fixedTimes?.fajrJamaat || timings.fajrJamaat,
    zuhrJamaat: fixedTimes?.zuhrJamaat || timings.zuhrJamaat,
    asrJamaat: fixedTimes?.asrJamaat || timings.asrJamaat,
    maghribJamaat: fixedTimes
      ? adjustTime(timings.maghrib, parseInt(fixedTimes.maghribJamaatOffset))
      : timings.maghribJamaat,
    ishaJamaat: fixedTimes?.ishaJamaat || timings.ishaJamaat,
    jumahJamaat: fixedTimes?.jumahJamaat || timings.jumahJamaat,
  };

  if (fixedTimes && fixedTimes.jumahJamaat2) {
    todayTimings.jumahJamaat2 = fixedTimes.jumahJamaat2;
  }

  return (
    <>
      {!("error" in details) && (
        <>
          <div className="d-flex justify-content-center">
            <div
              className="card"
              style={{
                width: "95%",
                background: "transparent",
                borderRadius: 24,
                color: "#ffffff",
                borderStyle: "none",
              }}
            >
              <div className="card-body">
                <h3
                  className="card-subtitle mb-2"
                  style={{ textAlign: "center" }}
                  lang={language === "urdu" && "ur"}
                >
                  {language === "urdu" ? details.urdName : details.engName}
                </h3>
                <p
                  className="card-text"
                  style={{
                    textAlign: "center",
                    color: "rgb(255, 255, 255, 0.8)",
                    marginBottom: 12,
                  }}
                  lang={language === "urdu" && "ur"}
                >
                  {language === "urdu" ? details.addressUrdu : details.address}
                </p>
                {details.isPrivate && (
                  <h5
                    className="card-text"
                    style={{
                      textAlign: "center",
                      color: "#e63946",
                      margin: 0,
                      fontStyle: "italic",
                    }}
                    lang={language === "urdu" && "ur"}
                  >
                    {language === "urdu"
                      ? "یہ مسجد عام عوام کے لئے کھلی نہیں ہے"
                      : "THIS MASJID IS NOT OPEN TO THE GENERAL PUBLIC"}
                  </h5>
                )}
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "95%",
                maxWidth: "800px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                  marginBottom: "12px",
                }}
              >
                <div style={{ flex: 1 }}>
                  <ShareButton masjidDetails={details} username={username} />
                </div>
                <div style={{ flex: 1 }}>
                  <FavouriteButton username={username} />
                </div>
              </div>

              <div
                style={{
                  marginBottom: "24px",
                }}
              >
                <MyMasjidButton username={username} />
              </div>

              <div
                className="card"
                style={{
                  borderRadius: 24,
                  overflow: "hidden",
                  boxShadow: "5px 5px 15px #021015",
                }}
              >
                <iframe
                  title="Masjid Location"
                  src={details.mapLink}
                  width="100%"
                  height="150"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </>
      )}
      {announcements.length > 0 && (
        <div
          className="d-flex d-lg-flex justify-content-center justify-content-lg-center"
          style={{ marginTop: 24 }}
        >
          <div
            className="card text-center"
            style={{
              width: "95%",
              maxWidth: "800px",
              background: "radial-gradient(circle, #0a3545, #041b23)",
              border: "3px solid rgb(27, 179, 200, 0.3)",
              borderRadius: 24,
              color: "#ffffff",
              boxShadow: "5px 5px 15px #021015",
            }}
          >
            <div className="card-body">
              <h4
                className="card-subtitle mb-2"
                style={{ textAlign: "center" }}
                lang={language === "urdu" && "ur"}
              >
                {language === "urdu" ? "اعلانات" : "Announcements"}
              </h4>

              {announcements.map((ann, index) => (
                <div key={index}>
                  <div className="row" style={{ marginTop: 24 }}>
                    <div className="col">
                      <p
                        style={{
                          marginBottom: 0,
                          textAlign: "left",
                          paddingLeft: "10px",
                        }}
                      >
                        {ann.englishText}
                      </p>
                    </div>
                    <div className="col">
                      <p
                        style={{
                          marginBottom: 0,
                          textAlign: "right",
                          paddingRight: "10px",
                        }}
                        dir="rtl"
                        lang="ur"
                      >
                        {ann.urduText}
                      </p>
                    </div>
                  </div>
                  {index < announcements.length - 1 && (
                    <div
                      style={{
                        border: "1px solid rgb(255, 255, 255, 0.7)",
                        margin: "12px 0",
                      }}
                    ></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div
        className="d-flex d-lg-flex justify-content-center justify-content-lg-center"
        style={{ marginTop: 24 }}
      >
        <div
          className="card text-center"
          style={{
            width: "95%",
            maxWidth: "800px",
            background: "radial-gradient(circle, #0a3545, #041b23)",
            border: "3px solid rgb(27, 179, 200, 0.3)",
            borderRadius: 24,
            color: "#ffffff",
            boxShadow: "5px 5px 15px #021015",
          }}
        >
          <div className="card-body">
            <h4
              className="card-subtitle mb-2"
              style={{ textAlign: "center" }}
              lang={language === "urdu" && "ur"}
            >
              {language === "urdu"
                ? "آج جماعت کے اوقات"
                : "Jamaat Timings Today"}
            </h4>
            {username !== "folio3" && (
              <div className="row" style={{ marginTop: 24 }}>
                <div className="col" style={{ alignSelf: "center" }}>
                  <h5>Fajr</h5>
                </div>
                <div className="col" style={{ alignSelf: "center" }}>
                  <h5>
                    {twentyFourToTwelve(adjustTime(todayTimings.fajrJamaat, 0))}
                  </h5>
                </div>
                <div className="col" style={{ alignSelf: "center" }}>
                  <h5 lang="ur">فجر</h5>
                </div>
              </div>
            )}
            <div className="row" style={{ marginTop: 12 }}>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5>Zuhr</h5>
              </div>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5>
                  {twentyFourToTwelve(adjustTime(todayTimings.zuhrJamaat, 0))}
                </h5>
                {username === "folio3" && (
                  <h5>
                    {twentyFourToTwelve(
                      adjustTime(todayTimings.zuhrJamaat, 20),
                    )}
                  </h5>
                )}
              </div>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5 lang="ur">ظہر</h5>
              </div>
            </div>
            {username === "folio3" && (
              <div className="row" style={{ marginTop: 24 }}>
                <div className="col" style={{ alignSelf: "center" }}>
                  <h5>Misl Awwal</h5>
                </div>
                <div className="col" style={{ alignSelf: "center" }}>
                  <h5>
                    {twentyFourToTwelve(adjustTime(todayTimings.fajrJamaat, 0))}
                  </h5>
                </div>
                <div className="col" style={{ alignSelf: "center" }}>
                  <h5 lang="ur">مثل اول</h5>
                </div>
              </div>
            )}
            <div className="row" style={{ marginTop: 12 }}>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5>Asr</h5>
              </div>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5>
                  {twentyFourToTwelve(adjustTime(todayTimings.asrJamaat, 0))}
                </h5>
                {username === "folio3" && (
                  <h5>
                    {twentyFourToTwelve(adjustTime(todayTimings.asrJamaat, 15))}
                  </h5>
                )}
              </div>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5 lang="ur">عصر</h5>
              </div>
            </div>
            <div className="row" style={{ marginTop: 12 }}>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5>Maghrib</h5>
              </div>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5>
                  {twentyFourToTwelve(
                    adjustTime(todayTimings.maghribJamaat, 0),
                  )}
                </h5>
              </div>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5 lang="ur">مغرب</h5>
              </div>
            </div>
            <div className="row" style={{ marginTop: 12 }}>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5>Isha</h5>
              </div>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5>
                  {twentyFourToTwelve(adjustTime(todayTimings.ishaJamaat, 0))}
                </h5>
              </div>
              <div className="col" style={{ alignSelf: "center" }}>
                <h5 lang="ur">عشاء</h5>
              </div>
            </div>
            {!(username === "folio3") && (
              <>
                {/* Horizontal line */}
                <div
                  className="row"
                  style={{
                    border: "1px solid rgb(255, 255, 255, 0.7)",
                    margin: "12px 0",
                  }}
                ></div>
                <div className="row" style={{ marginTop: 12 }}>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h5>Jumah</h5>
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h5>
                      {twentyFourToTwelve(
                        adjustTime(todayTimings.jumahJamaat, 0),
                      )}
                    </h5>
                    {username === "masjidhamid" && (
                      <h5>
                        {twentyFourToTwelve(
                          adjustTime(todayTimings.jumahJamaat2, 0),
                        )}
                      </h5>
                    )}
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h5 lang="ur">جمعہ</h5>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {!fixedTimes && (
        <div
          className="d-flex d-lg-flex justify-content-center justify-content-lg-center"
          style={{ marginTop: 24 }}
        >
          <div
            className="card text-center"
            style={{
              width: "95%",
              maxWidth: "800px",
              background: "radial-gradient(circle, #0a3545, #041b23)",
              border: "3px solid rgb(27, 179, 200, 0.3)",
              borderRadius: 24,
              color: "#ffffff",
              boxShadow: "5px 5px 15px #021015",
            }}
          >
            <div className="card-body">
              <h4
                className="card-subtitle mb-2"
                style={{ textAlign: "center" }}
                lang={language === "urdu" && "ur"}
              >
                {language === "urdu"
                  ? "جماعت آئندہ تبدیلی"
                  : "Changes in Jamaat Timings"}
              </h4>

              {!noNextChanges.fajr.includes(username) && (
                <div className="row" style={{ marginTop: 24 }}>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6 style={{ marginBottom: 0 }}>
                      {username === "folio3" ? "Misl Awwal" : "Fajr"}
                    </h6>
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6 style={{ marginBottom: 0 }}>
                      {twentyFourToTwelve(nextChanges.fajrJamaat.time)}
                    </h6>
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6
                      style={{
                        marginBottom: 0,
                        whiteSpace: "nowrap",
                      }}
                      dir={language === "urdu" ? "rtl" : "ltr"}
                    >
                      {formatDate(
                        nextChanges.fajrJamaat.day,
                        nextChanges.fajrJamaat.month,
                        details.calendar,
                      )}
                    </h6>
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6 style={{ marginBottom: 0 }} lang="ur">
                      {username === "folio3" ? "مثل اول" : "فجر"}
                    </h6>
                  </div>
                </div>
              )}
              {!noNextChanges.asr.includes(username) && (
                <div className="row" style={{ marginTop: 24 }}>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6 style={{ marginBottom: 0 }}>Asr</h6>
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6 style={{ marginBottom: 0 }}>
                      {twentyFourToTwelve(nextChanges.asrJamaat.time)}
                    </h6>
                    {username === "folio3" && (
                      <h6>
                        {twentyFourToTwelve(
                          adjustTime(nextChanges.asrJamaat.time, 15),
                        )}
                      </h6>
                    )}
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6
                      style={{
                        marginBottom: 0,
                        whiteSpace: "nowrap",
                      }}
                      dir={language === "urdu" ? "rtl" : "ltr"}
                    >
                      {formatDate(
                        nextChanges.asrJamaat.day,
                        nextChanges.asrJamaat.month,
                        details.calendar,
                      )}
                    </h6>
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6 style={{ marginBottom: 0 }} lang="ur">
                      عصر
                    </h6>
                  </div>
                </div>
              )}
              {!noNextChanges.isha.includes(username) && (
                <div className="row" style={{ marginTop: 24 }}>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6 style={{ marginBottom: 0 }}>Isha</h6>
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6 style={{ marginBottom: 0 }}>
                      {twentyFourToTwelve(nextChanges.ishaJamaat.time)}
                    </h6>
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6
                      style={{
                        marginBottom: 0,
                        whiteSpace: "nowrap",
                      }}
                      dir={language === "urdu" ? "rtl" : "ltr"}
                    >
                      {formatDate(
                        nextChanges.ishaJamaat.day,
                        nextChanges.ishaJamaat.month,
                        details.calendar,
                      )}
                    </h6>
                  </div>
                  <div className="col" style={{ alignSelf: "center" }}>
                    <h6 style={{ marginBottom: 0 }} lang="ur">
                      عشاء
                    </h6>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {username === "masjidrabbani" && (
        <div
          className="d-flex d-lg-flex justify-content-center justify-content-lg-center"
          style={{ marginTop: 24 }}
        >
          <div
            className="card text-center"
            style={{
              width: "95%",
              maxWidth: "800px",
              background: "radial-gradient(circle, #0a3545, #041b23)",
              border: "3px solid rgb(27, 179, 200, 0.3)",
              borderRadius: 24,
              color: "#ffffff",
              boxShadow: "5px 5px 15px #021015",
            }}
          >
            <div className="card-body">
              <h4
                className="card-subtitle mb-2"
                style={{ textAlign: "center" }}
                lang={language === "urdu" && "ur"}
              >
                {language === "urdu" ? "بیانات" : "Bayanaat"}
              </h4>
              <a
                href="https://rabbani-masjid.web.app"
                style={{
                  color: "rgb(27, 179, 200)",
                  textDecoration: "underline",
                }}
              >
                rabbani-masjid.web.app
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MasjidInfo;
